import { Component, OnInit, OnDestroy, ChangeDetectorRef} from '@angular/core';
import { Router , ActivatedRoute} from '@angular/router';
import { SDGComponent, Result, ResultData, QuestionCategoryGroup, QuestionCategoryType, QuestionType } from '../../_models/index';
import { AlertService, SDGComponentService, ResultService } from '../../_services/index';
import { Observable } from 'rxjs/Observable';
import { Subscription } from 'rxjs/Subscription';
import { environment } from '../../../environments/environment';
import * as GlobalVariables from '../globals/globals';
import { Chart } from 'chart.js';
import 'chartjs-plugin-datalabels';
import * as jsPDF from 'jspdf';
import * as $ from 'jquery';

var COMP = environment.component.status;
var cc = GlobalVariables.ChartConfig;

interface Row {
  catid:number;
  scatid:number;
  qcatid:number;
  cat:string;
  cspan:number;
  scat:string;
  scspan:number;
  qcat:string;
  qcspan:number;
  nasiv:any;
  nasivspan:number;
  ssim:string;
  ssimspan:number;
  unit1:string;
  unit1span:number;
  measure:string;
  unit2:string;
  baseline:number;
  current:number;
  aspiration:number;
  change_16_17:any;
  changespan:number;
  percent_of_2030:any;
  percentspan:number;
  cat_class:string;
  scat_class:string;
}

@Component({
  selector: 'app-status-report',
  templateUrl: './status-report.component.html',
  styleUrls: ['./status-report.component.css']
})
export class StatusReportComponent implements OnInit, OnDestroy {

  lang = 1;
  loading = true;
  translation : any;
  sdgcomponent$ : Observable<SDGComponent>;
  results$ : Observable<Result[]>;
  subscription1:Subscription;
  subscription2:Subscription;
  rows: Array<Row>=[];
  rows_final: Array<Row>=[];
  chart1 = [];
  chart2 = [];
  chart3 = [];
  chart4 = [];
  chart5 = [];
  chart6 = [];
  chart7 = [];
  chart8 = [];
  chart9 = [];
  grp_map_qtod = {
    '3':2,
    '4':3,
    '5':5,
    '6':7,
    '7':9,
    '8':10,
    '9':11,
    '10':12,
    '12':13,
    '13':14,
    '14':16,
    '15':17,
    '16':18,
    '17':19,
    '18':20,
    '19':21,
    '20':22,
    '21':24,
    '22':25,
    '23':26,
    '24':28,
    '25':29,
    '26':30,
    '27':31,
    '28':32,
    '29':33,
    '30':35,
    '31':37,
    '32':38,
    '33':39
  };

  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private sdgComponentService: SDGComponentService,
    private alertService: AlertService,
    private resultService: ResultService,
    private chRef: ChangeDetectorRef
    ) { }

  ngOnInit() {
    $(".header_active").removeClass("header_active")
    $(".status-click").addClass("header_active")

    this.lang = GlobalVariables.findTranslationOptionsIndex(window);

    this.translation = GlobalVariables.option_translations[this.lang];
    this.results$ = this.resultService.getAll(COMP);
    this.sdgcomponent$ = this.sdgComponentService.getAll(COMP);
    this.subscription1 = this.sdgcomponent$.subscribe( data => {
      var categories = data.category;
      var ordered_categories = [];
      var cl = categories.length;

      //reordering categories based on order field in each categrory
      for(var i = 0; i< cl; i++){
        ordered_categories[categories[i].order-1] = categories[i];
      }
      //reordering sub_categories based on order field in each sub_categrory
      for(var i = 0; i< cl; i++){
        var oc_sc = ordered_categories[i].sub_category;
        var oc_osc = [];
        for(var j = 0; j< oc_sc.length; j++){
            oc_osc[oc_sc[j].order-1] = oc_sc[j];
        }
        ordered_categories[i].sub_category = oc_osc;
      }
      //reordering question_categories based on order field in each question_categrory
      for(var i = 0; i< cl; i++){
        var oc_sc = ordered_categories[i].sub_category;
        for(var j = 0; j< oc_sc.length; j++){
          var qc = oc_sc[j].question_category;
          var oqc = [],oqc1 = [];
          for(var k = 0; k < qc.length; k++){
            oqc[qc[k].order-1] = qc[k];
          }
          var oqci=0;
          while(!oqc[oqci]) oqci++;
          for (var m=0; m < (oqc.length-oqci); m++)
            oqc1[m] = oqc[m+oqci];
          ordered_categories[i].sub_category[j].question_category = oqc1;
        }
      }
      for(var i = 0; i< cl; i++){
        var oc_sc = ordered_categories[i].sub_category;
        for(var j = 0; j< oc_sc.length; j++){
          var qc = oc_sc[j].question_category;
          for(var k = 0; k < qc.length; k++){
            var q = qc[k].question;
            var oq = [], oq1=[];
            for(var l = 0; l < q.length; l++){
              var qn = q[l];
              var idx = qn.question_grp * 3 + qn.order -1;
              oq[idx] = q[l];
            }
            var oqi=0;
            while(!oq[oqi]) oqi++;
            for (var m=0, n=0; m < (oq.length-oqi); m++)
            if(oq[m+oqi])
              oq1[n++] = oq[m+oqi];
            ordered_categories[i].sub_category[j].question_category[k].question = oq1;
          }
        }
      }
      data.category = ordered_categories;
      var cspans = {}, scspans = {}, qcspans = {};
      var rows1 = [];
      var cat_class = ['blue1','blue2'];
      var scat_class = ['blue3','blue4'];
      var measure_class = ['white','yellow'];

      for(var i = 1; i < data.category.length; i++){
        var cur_cat = data.category[i];
        cspans[cur_cat.id] = 0;

        for(var j = 0; j < cur_cat.sub_category.length; j++){
          var cur_scat = data.category[i].sub_category[j]
          scspans[cur_scat.id] = 0;

          for(var k = 0; k < cur_scat.question_category.length; k++){
            var cur_qcat = data.category[i].sub_category[j].question_category[k];
            qcspans[cur_qcat.id] = 0;
            var qcat_qtype = cur_qcat.question_type;
                var qgroup = 0;

            for(var l = 0; l < cur_qcat.question.length; l++){
              var cur_ques = cur_qcat.question[l];
                //map row index (question group) from questionairre sheet ordering to data sheet ordering
              var qgrp = cur_ques.question_grp;
              var dgrp = this.grp_map_qtod[qgrp.toString()];
              if(dgrp && !rows1[dgrp]){
                //add a row indexed by question group as soon as the first question from this group is encountered
                rows1[dgrp] = {
                  catid:cur_cat.id,
                  scatid:cur_scat.id,
                  cat:cur_cat.name,
                  scat:cur_scat.name,
                  qcat:cur_qcat.name,
                  cspan:0,
                  scspan:0,
                  measure:cur_ques.question_text,
                  unit2:'',
                  baseline:0,
                  current:0,
                  aspiration:0,
                  cat_class:cat_class[i%2],
                  scat_class:scat_class[i%2],
                  measure_class: measure_class[0]
                }
                //keep span values for each or c,sc and qc in separate objects
                cspans[cur_cat.id]++;
                scspans[cur_scat.id]++;
                qcspans[cur_qcat.id]++;
              }
            }
          }
        }
      }
      var computed_rows = [1,2,4,6,8,15,23,27,34,36,40];
      for (var cr = 0; cr < computed_rows.length; cr++){
        var dgrp;
         dgrp = computed_rows[cr];
        //add a row indexed by question group as soon as the first question from this group is encountered
        rows1[dgrp] = {
          catid:null,
          scatid:null,
          cat:'',
          scat:'',
          qcat:'',
          cspan:0,
          scspan:0,
          measure:'',
          unit2:'',
          baseline:0,
          current:0,
          aspiration:0,
          cat_class:'',
          scat_class:'',
          measure_class: measure_class[1]
        }
      }
      this.rows = rows1;

    this.results$.subscribe( data => {
      var rows1 = this.rows;

      for(var i=0;i<data.length;i++){
        var res = data[i];
        //map row index (question group) from questionairre sheet ordering to data sheet ordering
        var qgrp = res.question_grp;
        var dgrp = this.grp_map_qtod[qgrp.toString()];
        if(dgrp){
        var f;
        if(res.value!=null && res.value!='')
          f = parseFloat(res.value);
        else
          f = res.value;

          if(res.question_type_order==1)
            rows1[dgrp]['baseline'] = f;
          else if(res.question_type_order==2)
            rows1[dgrp]['current'] = f;
          else if(res.question_type_order==3)
            rows1[dgrp]['aspiration'] = f;
        }
        if (qgrp == 1)
        if(res.value!=null && res.value!='')
          rows1[1]['baseline'] = parseInt(res.value);

        if (qgrp == 2)
        if(res.value!=null && res.value!='')
          rows1[1]['current'] = parseInt(res.value);

        rows1[1]['aspiration'] = 2030;
      }

        //9(excel row) -5 = 4(data page group)
        //E9=100*E8/E7, F, G
        rows1[4].baseline = 100*rows1[3].baseline/rows1[2].baseline;
        rows1[4].current = 100*rows1[3].current/rows1[2].current;
        rows1[4].aspiration = 100*rows1[3].aspiration/rows1[2].aspiration;
        //E11=100*E10/E7, F, G
        rows1[6].baseline = 100*rows1[5].baseline/rows1[2].baseline;
        rows1[6].current = 100*rows1[5].current/rows1[2].current;
        rows1[6].aspiration = 100*rows1[5].aspiration/rows1[2].aspiration;
        //E13=100*E12/E7, F, G
        rows1[8].baseline = 100*rows1[7].baseline/rows1[2].baseline;
        rows1[8].current = 100*rows1[7].current/rows1[2].current;
        rows1[8].aspiration = 100*rows1[7].aspiration/rows1[2].aspiration;
        //E20=100*E18/E19, F, G
        rows1[15].baseline = 100*rows1[13].baseline/rows1[14].baseline;
        rows1[15].current = 100*rows1[13].current/rows1[14].current;
        rows1[15].aspiration = 100*rows1[13].aspiration/rows1[14].aspiration;

        //E28=(E23*(1-E24/100)/E25)*(E25/(E22+E25+E27))+(E21/E22)*(E22/(E22+E25+E27))+(E26/E27)*(E27/(E22+E25+E27))
        //F28=(F23*(1-F24/100)/F25)*(F25/(F22+F25+F27))+(F21/F22)*(F22/(F22+F25+F27))+(F26/F27)*(F27/(F22+F25+F27))
        //G28=(G23*(1-G24/100)/G25)*(G25/(G22+G25+G27))+(G21/G22)*(G22/(G22+G25+G27))+(G26/G27)*(G27/(G22+G25+G27))

        rows1[23].baseline = (rows1[18].baseline*(1-rows1[19].baseline/100)/rows1[20].baseline)*
        (rows1[20].baseline/(rows1[17].baseline+rows1[20].baseline+rows1[22].baseline))+
        (rows1[16].baseline/rows1[17].baseline)*
        (rows1[17].baseline/(rows1[17].baseline+rows1[20].baseline+rows1[22].baseline))+
        (rows1[21].baseline/rows1[22].baseline)*
        (rows1[22].baseline/(rows1[17].baseline+rows1[20].baseline+rows1[22].baseline));

        rows1[23].current = (rows1[18].current*(1-rows1[19].current/100)/rows1[20].current)*
        (rows1[20].current/(rows1[17].current+rows1[20].current+rows1[22].current))+
        (rows1[16].current/rows1[17].current)*
        (rows1[17].current/(rows1[17].current+rows1[20].current+rows1[22].current))+
        (rows1[21].current/rows1[22].current)*
        (rows1[22].current/(rows1[17].current+rows1[20].current+rows1[22].current));

        rows1[23].aspiration = (rows1[18].aspiration*(1-rows1[19].aspiration/100)/rows1[20].aspiration)*
        (rows1[20].aspiration/(rows1[17].aspiration+rows1[20].aspiration+rows1[22].aspiration))+
        (rows1[16].aspiration/rows1[17].aspiration)*
        (rows1[17].aspiration/(rows1[17].aspiration+rows1[20].aspiration+rows1[22].aspiration))+
        (rows1[21].aspiration/rows1[22].aspiration)*
        (rows1[22].aspiration/(rows1[17].aspiration+rows1[20].aspiration+rows1[22].aspiration));

        //E32=100*E30/(E29-E31), F, G
        rows1[27].baseline=100*rows1[25].baseline/(rows1[24].baseline-rows1[26].baseline);
        rows1[27].current=100*rows1[25].current/(rows1[24].current-rows1[26].current);
        rows1[27].aspiration=100*rows1[25].aspiration/(rows1[24].aspiration-rows1[26].aspiration);

        //E39=100*E37/E38
        rows1[34].baseline = 100*rows1[32].baseline/rows1[33].baseline;
        rows1[34].current = 100*rows1[32].current/rows1[33].current;
        rows1[34].aspiration = 100*rows1[32].aspiration/rows1[33].aspiration;

        //F41=100*(F40-E40)/E40
        //G41=100*((G40-E40)/E40)
        rows1[36].current=100*(rows1[35].current-rows1[35].baseline)/rows1[35].baseline;
        rows1[36].aspiration=100*((rows1[35].aspiration-rows1[35].baseline)/rows1[35].baseline);

        //F45=((F42+F43+F44)-(E42+E43+E44)/(E42+E43+E44))
        //G45=((G42+G43+G44)-(E42+E43+E44)/(E42+E43+E44))
        rows1[40].current =
        ((rows1[37].current+rows1[38].current+rows1[39].current)-
        (rows1[37].baseline+rows1[38].baseline+rows1[39].baseline)/
        (rows1[37].baseline+rows1[38].baseline+rows1[39].baseline));

        rows1[40].aspiration =
        ((rows1[37].aspiration+rows1[38].aspiration+rows1[39].aspiration)-
        (rows1[37].baseline+rows1[38].baseline+rows1[39].baseline)/
        (rows1[37].baseline+rows1[38].baseline+rows1[39].baseline));

        var computed_rows = [4,6,8,15,23,27,34,36,40];
        for (var cr = 0; cr < computed_rows.length; cr++){
          var dgrp;
          dgrp = computed_rows[cr];
          var val = rows1[dgrp].baseline;
          if(val!=null && !Number.isNaN(val))
            val = parseFloat(val.toFixed(1));
          rows1[dgrp].baseline = val;

          var val = rows1[dgrp].current;
          if(val!=null && !Number.isNaN(val))
            val = parseFloat(val.toFixed(1));
          rows1[dgrp].current = val;

          var val = rows1[dgrp].aspiration;
          if(val!=null && !Number.isNaN(val))
            val = parseFloat(val.toFixed(1));
          rows1[dgrp].aspiration = val;
        }


      var chart1_bar_xlabels = [this.translation['baseline'], this.translation['current'], '2030'];
      var b=rows1[4].baseline;
      var c=rows1[4].current;
      var a=rows1[4].aspiration;
      var chart1_bar_values = [b,c,a];
      var chart1_bar_ytitle = this.translation['Percentage'];

      var chart2_bar_xlabels = [this.translation['baseline'], this.translation['current'], '2030'];
      var b1=rows1[6].baseline;
      var c1=rows1[6].current;
      var a1=rows1[6].aspiration;
      var b2=rows1[8].baseline;
      var c2=rows1[8].current;
      var a2=rows1[8].aspiration;
      var chart2_bar_values1 = [b1,c1,a1];
      var chart2_bar_values2 = [b2,c2,a2];
//      var chart2_bar_values1 = [20,40,60];
//      var chart2_bar_values2 = [30,50,80];
      var chart2_bar_ytitle = this.translation['Percentage'];

      var chart3_bar_xlabels = [this.translation['baseline'], this.translation['current'], '2030'];
      var b1=rows1[9].baseline;
      var c1=rows1[9].current;
      var a1=rows1[9].aspiration;
      var b2=rows1[10].baseline;
      var c2=rows1[10].current;
      var a2=rows1[10].aspiration;
      var b3=rows1[11].baseline;
      var c3=rows1[11].current;
      var a3=rows1[11].aspiration;
      var b4=rows1[12].baseline;
      var c4=rows1[12].current;
      var a4=rows1[12].aspiration;
      var chart3_bar_values1 = [b1,c1,a1];
      var chart3_bar_values2 = [b2,c2,a2];
      var chart3_bar_values3 = [b3,c3,a3];
      var chart3_bar_values4 = [b4,c4,a4];
      var chart3_bar_ytitle = this.translation['Percentage'];

      var chart4_bar_xlabels = [this.translation['baseline'], this.translation['current'], '2030'];
      var b=rows1[15].baseline;
      var c=rows1[15].current;
      var a=rows1[15].aspiration;
      var chart4_bar_values = [b,c,a];
      var chart4_bar_ytitle = this.translation['Percentage'];

      var chart5_bar_xlabels = [this.translation['baseline'], this.translation['current'], '2030'];
      var b=rows1[23].baseline;
      var c=rows1[23].current;
      var a=rows1[23].aspiration;
      var chart5_bar_values = [b,c,a];
      var chart5_bar_ytitle = this.translation['USD/m3'];


      var chart6_bar_xlabels = [this.translation['baseline'], this.translation['current'], '2030'];
      var b=rows1[27].baseline;
      var c=rows1[27].current;
      var a=rows1[27].aspiration;
      var chart6_bar_values = [b,c,a];
//      var chart6_bar_values = [11,66,44];
      var chart6_bar_ytitle = this.translation['Percentage'];

      var chart7_bar_xlabels = [[this.translation['Enabling'],this.translation['environment score']],
        [this.translation['Institutions and'],this.translation['participation score']],
        [this.translation['Management'],this.translation['instruments score']],
        this.translation['Financing score']];
      var b1=rows1[28].baseline;
      var c1=rows1[28].current;
      var a1=rows1[28].aspiration;
      var b2=rows1[29].baseline;
      var c2=rows1[29].current;
      var a2=rows1[29].aspiration;
      var b3=rows1[30].baseline;
      var c3=rows1[30].current;
      var a3=rows1[30].aspiration;
      var b4=rows1[31].baseline;
      var c4=rows1[31].current;
      var a4=rows1[31].aspiration;
      var chart7_bar_values1 = [b1,b2,b3,b4];
      var chart7_bar_values2 = [c1,c2,c3,c4];
      var chart7_bar_values3 = [a1,a2,a3,a4];
      var chart7_bar_ytitle = this.translation['Score (0-100)'];

      var chart8_bar_xlabels = [this.translation['baseline'], this.translation['current'], '2030'];
      var b=rows1[34].baseline;
      var c=rows1[34].current;
      var a=rows1[34].aspiration;
      var chart8_bar_values = [b,c,a];
//      var chart8_bar_values = [10,15,20];
      var chart8_bar_ytitle = this.translation['Percentage'];

      var chart9_bar_xlabels = [this.translation['current'], '2030'];
      var c1=rows1[36].current;
      var a1=rows1[36].aspiration;
      var c2=rows1[40].current;
      var a2=rows1[40].aspiration;
      var chart9_bar_values1 = [c1,a1];
      var chart9_bar_values2 = [c2,a2];
//      var chart9_bar_values1 = [20,40,60];
//      var chart9_bar_values2 = [30,50,80];
      var chart9_bar_ytitle = this.translation['Percentage'];
      var chart9_max = c1;
      if (a1>chart9_max) chart9_max = a1;
      if (c2>chart9_max) chart9_max = c2;
      if (a2>chart9_max) chart9_max = a2;
      if (chart9_max <= 100){
        chart9_max = 100;
      }
      else{
      var diff = chart9_max - 100;
        diff = diff/20;
        diff = Math.ceil(diff);
        chart9_max = 100 + diff * 20;
      }
      var chart9_min = c1;
      if (a1<chart9_min) chart9_min = a1;
      if (c2<chart9_min) chart9_min = c2;
      if (a2<chart9_min) chart9_min = a2;
      if (chart9_min >= 0){
        chart9_min = 0;
      }
      else{
      var diff = chart9_min * -1;
        diff = diff/20;
        diff = Math.ceil(diff);
        chart9_min = 0 - diff * 20;
      }

      var chart1_title = Object.assign({}, cc.chart_title);
      var chart2_title = Object.assign({}, cc.chart_title);
      var chart3_title = Object.assign({}, cc.chart_title);
      var chart4_title = Object.assign({}, cc.chart_title);
      var chart5_title = Object.assign({}, cc.chart_title);
      var chart6_title = Object.assign({}, cc.chart_title);
      var chart7_title = Object.assign({}, cc.chart_title);
      var chart8_title = Object.assign({}, cc.chart_title);
      var chart9_title = Object.assign({}, cc.chart_title);
      chart1_title.text = [this.translation['6.1.1 Proportion of population using'],this.translation['safely managed drinking water services']];
      chart2_title.text = [this.translation['6.2.1 Proportion of population using'],this.translation['safely managed sanitation services']];
      chart3_title.text = [this.translation['6.3.1 Proportion of wastewater safely treated']];
      chart4_title.text = [this.translation['6.3.2 Proportion of water bodies with good ambient water quality']];
      chart5_title.text = [this.translation['6.4.1 Change in water use efficiency over time']];
      chart6_title.text = [this.translation['6.4.2 Level of water stress: freshwater withdrawal'],this.translation['in percentage of available freshwater resources']];
      chart7_title.text = [this.translation['6.5.1 Degree of integrated water resources management']];
      chart8_title.text = [this.translation['6.5.2 Proportion of transboundary basin area with'],this.translation['an operational arrangement for water cooperation']];
      chart9_title.text = [...this.translation['6.6.1 Change in the extent of water-related ecosystems over time']];

      this.chart1 = new Chart('canvas1', {
        type: 'bar',
        data:{
          labels: chart1_bar_xlabels,
          datasets: [{
              data: chart1_bar_values,
              borderWidth: 1,
              backgroundColor: cc.barchart_colors[0],
              datalabels : cc.percentage_datalabels_small_white
          }]
        },
        options: {
          tooltips: cc.barchart_tooltips,
          responsive: false,
          layout: cc.barchart_layout,
          title : chart1_title,
          legend: cc.barchart_legend,
          scales: {
            yAxes: [{
              display: true,
              ticks: cc.percentage_ticks,
              scaleLabel: {
                  fontSize: 20,
                  display: true,
                  labelString: chart1_bar_ytitle
              }
            }],
            xAxes: [{
              barPercentage: 0.3,
              display: true,
              ticks: cc.data_ticks
            }],
          }
        }
      });

      this.chart2 = new Chart('canvas2', {
        type: 'bar',
        data:{
          labels: chart2_bar_xlabels,
          datasets: [{
              label: this.translation['Population using improved sanitation services'],
              data: chart2_bar_values1,
              borderWidth: 1,
              backgroundColor: cc.barchart_colors[0],
              datalabels : cc.percentage_datalabels_small_white
          },
          {
              label: this.translation['Population using hygiene facility with soap and water at home'],
              data: chart2_bar_values2,
              borderWidth: 1,
              backgroundColor: cc.barchart_colors[1],
              datalabels : cc.percentage_datalabels_small
          }]
        },
        options: {
          legend: cc.barchart_legend_bottom,
          tooltips: cc.barchart_tooltips,
          responsive: false,
          layout: cc.barchart_layout,
          title : chart2_title,
          scales: {
            yAxes: [{
              display: true,
              ticks: cc.percentage_ticks,
              scaleLabel: {
                  fontSize: 20,
                  display: true,
                  labelString: chart2_bar_ytitle
              }
            }],
            xAxes: [{
              categoryPercentage: 0.5,
              barPercentage: 0.7,
              display: true,
              ticks: cc.data_ticks
            }],
          }
        }
      });

      this.chart3 = new Chart('canvas3', {
        type: 'bar',
        data:{
          labels: chart3_bar_xlabels,
          datasets: [{
              label: this.translation['Commercial establishments'],
              data: chart3_bar_values1,
              borderWidth: 1,
              backgroundColor: cc.barchart_colors[0],
              datalabels : cc.percentage_datalabels_small_white
          },
          {
              label: this.translation['Non-hazardous industries'],
              data: chart3_bar_values2,
              borderWidth: 1,
              backgroundColor: cc.barchart_colors[1],
              datalabels : cc.percentage_datalabels_small
          },
          {
              label: this.translation['Hazardous industries'],
              data: chart3_bar_values3,
              borderWidth: 1,
              backgroundColor: cc.barchart_colors[2],
              datalabels : cc.percentage_datalabels_small
          },
          {
              label: this.translation['Household sources'],
              data: chart3_bar_values4,
              borderWidth: 1,
              backgroundColor: cc.barchart_colors[3],
              datalabels : cc.percentage_datalabels_small_white
          }]
        },
        options: {
          legend: cc.barchart_legend_bottom,
          tooltips: cc.barchart_tooltips,
          responsive: false,
          layout: cc.barchart_layout,
          title : chart3_title,
          scales: {
            yAxes: [{
              display: true,
              ticks: cc.percentage_ticks,
              scaleLabel: {
                  fontSize: 20,
                  display: true,
                  labelString: chart3_bar_ytitle
              }
            }],
            xAxes: [{
              categoryPercentage: 0.5,
              barPercentage: 0.8,
              display: true,
              ticks: cc.data_ticks
            }],
          }
        }
      });

      this.chart4 = new Chart('canvas4', {
        type: 'bar',
        data:{
          labels: chart4_bar_xlabels,
          datasets: [{
              data: chart4_bar_values,
              borderWidth: 1,
              backgroundColor: cc.barchart_colors[0],
              datalabels : cc.percentage_datalabels_small_white
          }]
        },
        options: {
          tooltips: cc.barchart_tooltips,
          responsive: false,
          layout: cc.barchart_layout,
          title : chart4_title,
          legend: cc.barchart_legend,
          scales: {
            yAxes: [{
              display: true,
              ticks: cc.percentage_ticks,
              scaleLabel: {
                  fontSize: 20,
                  display: true,
                  labelString: chart4_bar_ytitle
              }
            }],
            xAxes: [{
              barPercentage: 0.3,
              display: true,
              ticks: cc.data_ticks
            }],
          }
        }
      });

      this.chart5 = new Chart('canvas5', {
        type: 'bar',
        data:{
          labels: chart5_bar_xlabels,
          datasets: [{
              data: chart5_bar_values,
              borderWidth: 1,
              backgroundColor: cc.barchart_colors[0],
              datalabels : cc.simple_datalabels
          }]
        },
        options: {
          tooltips: cc.barchart_tooltips,
          responsive: false,
          layout: cc.barchart_layout,
          title : chart5_title,
          legend: cc.barchart_legend,
          scales: {
            yAxes: [{
              display: true,
              ticks: cc.simple_ticks,
              scaleLabel: {
                  fontSize: 20,
                  display: true,
                  labelString: chart5_bar_ytitle
              }
            }],
            xAxes: [{
              barPercentage: 0.3,
              display: true,
              ticks: cc.data_ticks
            }],
          }
        }
      });

      this.chart6 = new Chart('canvas6', {
        type: 'bar',
        data:{
          labels: chart6_bar_xlabels,
          datasets: [{
              data: chart6_bar_values,
              borderWidth: 1,
              backgroundColor: cc.barchart_colors[0],
              datalabels : cc.percentage_datalabels_small_white
          }]
        },
        options: {
          tooltips: cc.barchart_tooltips,
          responsive: false,
          layout: cc.barchart_layout,
          title : chart6_title,
          legend: cc.barchart_legend,
          scales: {
            yAxes: [{
              display: true,
              ticks: cc.percentage_ticks,
              scaleLabel: {
                  fontSize: 20,
                  display: true,
                  labelString: chart6_bar_ytitle
              }
            }],
            xAxes: [{
              barPercentage: 0.3,
              display: true,
              ticks: cc.data_ticks
            }],
          }
        }
      });

      this.chart7 = new Chart('canvas7', {
        type: 'bar',
        data:{
          labels: chart7_bar_xlabels,
          datasets: [{
              label: this.translation['baseline'],
              data: chart7_bar_values1,
              borderWidth: 1,
              backgroundColor: cc.barchart_colors[0],
              datalabels : cc.simple_datalabels
          },
          {
              label: this.translation['current'],
              data: chart7_bar_values2,
              borderWidth: 1,
              backgroundColor: cc.barchart_colors[1],
              datalabels : cc.simple_datalabels_black
          },
          {
              label: '2030',
              data: chart7_bar_values3,
              borderWidth: 1,
              backgroundColor: cc.barchart_colors[3],
              datalabels : cc.simple_datalabels_black
          }]
        },
        options: {
          legend: cc.barchart_legend_bottom,
          tooltips: cc.barchart_tooltips,
          responsive: false,
          layout: cc.barchart_layout,
          title : chart7_title,
          scales: {
            yAxes: [{
              display: true,
              ticks: cc.score_ticks,
              scaleLabel: {
                  fontSize: 20,
                  display: true,
                  labelString: chart7_bar_ytitle
              }
            }],
            xAxes: [{
              categoryPercentage: 0.5,
              barPercentage: 1.0,
              display: true,
              ticks: cc.data_ticks
            }],
          }
        }
      });

      this.chart8 = new Chart('canvas8', {
        type: 'bar',
        data:{
          labels: chart8_bar_xlabels,
          datasets: [{
              data: chart8_bar_values,
              borderWidth: 1,
              backgroundColor: cc.barchart_colors[0],
              datalabels : cc.percentage_datalabels_small_white
          }]
        },
        options: {
          tooltips: cc.barchart_tooltips,
          responsive: false,
          layout: cc.barchart_layout,
          title : chart8_title,
          legend: cc.barchart_legend,
          scales: {
            yAxes: [{
              display: true,
              ticks: cc.percentage_ticks,
              scaleLabel: {
                  fontSize: 20,
                  display: true,
                  labelString: chart8_bar_ytitle
              }
            }],
            xAxes: [{
              barPercentage: 0.3,
              display: true,
              ticks: cc.data_ticks
            }],
          }
        }
      });

      this.chart9 = new Chart('canvas9', {
        type: 'bar',
        data:{
          labels: chart9_bar_xlabels,
          datasets: [{
              label: this.translation['Change in the area extent of water-related ecosystems'],
              data: chart9_bar_values1,
              borderWidth: 1,
              backgroundColor: cc.barchart_colors[0],
              datalabels : cc.percentage_datalabels_small_white
          },
          {
              label: this.translation['Change in quantity of water contained within these ecosystems'],
              data: chart9_bar_values2,
              borderWidth: 1,
              backgroundColor: cc.barchart_colors[1],
              datalabels : cc.percentage_datalabels_small
          }]
        },
        options: {
          legend: cc.barchart_legend_bottom,
          tooltips: cc.barchart_tooltips,
          responsive: false,
          layout: cc.barchart_layout,
          title : chart9_title,
          scales: {
            yAxes: [{
              display: true,
              ticks: {
                  fontSize: 18,
                  beginAtZero:true,
                  stepSize: 20,
                  min:chart9_min,
                  max:chart9_max,
                  callback: function(value, index, values) {
                      return value + '%';
                  }
              },
              scaleLabel: {
                  fontSize: 20,
                  display: true,
                  labelString: chart9_bar_ytitle
              }
            }],
            xAxes: [{
              categoryPercentage: 0.5,
              barPercentage: 0.7,
              display: true,
              ticks: cc.data_ticks
            }],
          }
        }
      });

        rows1.splice(0,1);
        this.rows_final = rows1;

        setInterval(() => {
          this.loading = false;
          this.chRef.markForCheck();
        }, 2000);
        data = null;
      },
      error => {
        this.alertService.error(error);
      });
      data = null;
    },
    error => {
      this.alertService.error(error);
    });
  }

  empty_objects(objects_arrays){
    for (var j=0; j<objects_arrays.length; j++){
      var props = Object.getOwnPropertyNames(objects_arrays[j]);
      for (var i = 0; i < props.length; i++) {
        delete objects_arrays[j][props[i]];
      }
    }
  }

  ngOnDestroy() {

    this.chart1 = null;
    this.chart9 = null;
    this.chart3 = null;
    this.chart4 = null;
    this.chart5 = null;
    this.chart6 = null;
    this.chart7 = null;
    this.chart8 = null;
    this.chart9 = null;
    this.rows = null;
    this.rows_final = null;

    if(this.subscription1)
      this.subscription1.unsubscribe();
    if(this.subscription2)
      this.subscription2.unsubscribe();
  }

  resourcesBtnClick(){
    this.router.navigateByUrl('/sdg/status')
  }

  quesBtnClick(){
    this.router.navigateByUrl('/sdg/status-quest')
  }
  dataBtnClick(){
    this.router.navigateByUrl('/sdg/status-data')
  }
  reportBtnClick(){
    this.router.navigateByUrl('/sdg/status-report')
  }

  exportBtnClick(){

        let doc = new jsPDF('landscape');
        let canvas = document.getElementsByTagName('canvas');
        for(var i=0;i<canvas.length;i++){
         let height = (297 * canvas[i].height)/canvas[i].width;
         let y = (210/2) - (height/2);
         doc.addImage(canvas[i].toDataURL("image/png"), "PNG",0,y,297,height);
           if(i<(canvas.length-1))
            doc.addPage();
        }
    doc.save('Status Report.pdf');
  }

  formatLabel(str, maxwidth){
    var sections = [];
    var words = str.split(" ");
    var temp = "";

    words.forEach(function(item, index){
        if(temp.length > 0){
            var concat = temp + ' ' + item;
            if(concat.length > maxwidth){
                sections.push(temp);
                temp = "";
            }
            else{
                if(index == (words.length-1)){
                    sections.push(concat);
                    return;
                }
                else{
                    temp = concat;
                    return;
                }
            }
        }
        if(index == (words.length-1)){
            sections.push(item);
            return;
        }
        if(item.length < maxwidth)
            temp = item;
        else
            sections.push(item);
    });
    return sections;
  }
}



// WEBPACK FOOTER //
// ./src/app/sdg/status-report/status-report.component.ts